const Constants = {};

Constants.EXP_TABLE = [
  0, 10, 30, 60, 120, 180, 250, 400, 550, 750, 1000, 1250, 1500, 1900, 2500,
];

Constants.BUTTONS = [
  {
    key: "E",
    text: "E",
  },
  {
    key: "plusminus",
    text: "±",
  },
  {
    key: "percent",
    text: "％",
  },
  {
    key: "division",
    text: "÷",
  },
  {
    key: "multiplication",
    text: "×",
  },
  {
    key: "subtraction",
    text: "－",
  },
  {
    key: "addition",
    text: "＋",
  },
  {
    key: "C",
    text: "C",
  },
  {
    key: "equal",
    text: "＝",
  },
  {
    key: "dot",
    text: "・",
  },
  {
    key: "0",
    text: "0",
  },
  {
    key: "1",
    text: "1",
  },
  {
    key: "2",
    text: "2",
  },
  {
    key: "3",
    text: "3",
  },
  {
    key: "4",
    text: "4",
  },
  {
    key: "5",
    text: "5",
  },
  {
    key: "6",
    text: "6",
  },
  {
    key: "7",
    text: "7",
  },
  {
    key: "8",
    text: "8",
  },
  {
    key: "9",
    text: "9",
  },
];

/** ボタンの表示設定 */
Constants.BUTTON_SETTINGS = [
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "E",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "C",
      row: "2 / span 1",
      col: "1 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "1 / span 3",
      col: "1 / span 3",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "E",
      row: "1 / span 1",
      col: "4 / span 1",
    },
    {
      key: "C",
      row: "2 / span 1",
      col: "4 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "2 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "3 / span 1",
      col: "3 / span 1",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "E",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "C",
      row: "4 / span 1",
      col: "2 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "4 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "4 / span 1",
      col: "3 / span 1",
    },
    {
      key: "4",
      row: "1 / span 1",
      col: "3 / span 1",
    },
    {
      key: "addition",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "equal",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "E",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "C",
      row: "5 / span 1",
      col: "3 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "4 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "4 / span 1",
      col: "3 / span 1",
    },
    {
      key: "4",
      row: "1 / span 1",
      col: "3 / span 1",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "subtraction",
      row: "3 / span 1",
      col: "4 / span 1",
    },
    {
      key: "E",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "C",
      row: "2 / span 1",
      col: "1 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "2 / span 1",
      col: "1 / span 1",
    },
    {
      key: "3",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "4",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "5",
      row: "5 / span 1",
      col: "1 / span 1",
    },
    {
      key: "addition",
      row: "1 / span 1",
      col: "2 / span 1",
    },
    {
      key: "equal",
      row: "1 / span 1",
      col: "3 / span 1",
    },
    {
      key: "subtraction",
      row: "1 / span 1",
      col: "4 / span 1",
    },
    {
      key: "E",
      row: "2 / span 2",
      col: "2 / span 2",
    },
    {
      key: "C",
      row: "4 / span 2",
      col: "2 / span 2",
    },
  ],
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "4 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "4 / span 1",
      col: "3 / span 1",
    },
    {
      key: "4",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "5",
      row: "3 / span 1",
      col: "2 / span 1",
    },
    {
      key: "6",
      row: "3 / span 1",
      col: "3 / span 1",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "subtraction",
      row: "3 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "E",
      row: "1 / span 1",
      col: "1 / span 4",
    },
    {
      key: "C",
      row: "2 / span 1",
      col: "1 / span 3",
    },
  ],
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "4 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "4 / span 1",
      col: "3 / span 1",
    },
    {
      key: "4",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "5",
      row: "3 / span 1",
      col: "2 / span 1",
    },
    {
      key: "6",
      row: "3 / span 1",
      col: "3 / span 1",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "subtraction",
      row: "3 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "plusminus",
      row: "1 / span 1",
      col: "2 / span 1",
    },
    {
      key: "E",
      row: "1 / span 1",
      col: "4 / span 1",
    },
    {
      key: "C",
      row: "2 / span 1",
      col: "4 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "2 / span 1",
      col: "1 / span 1",
    },
    {
      key: "3",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "4",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "5",
      row: "5 / span 1",
      col: "1 / span 1",
    },
    {
      key: "6",
      row: "5 / span 1",
      col: "2 / span 1",
    },
    {
      key: "7",
      row: "5 / span 1",
      col: "3 / span 1",
    },
    {
      key: "8",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "9",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "addition",
      row: "3 / span 1",
      col: "4 / span 1",
    },
    {
      key: "subtraction",
      row: "2 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "1 / span 1",
      col: "4 / span 1",
    },
    {
      key: "plusminus",
      row: "1 / span 3",
      col: "2 / span 2",
    },
    {
      key: "E",
      row: "4 / span 1",
      col: "2 / span 1",
    },
    {
      key: "C",
      row: "4 / span 1",
      col: "3 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "1 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "1 / span 1",
      col: "3 / span 1",
    },
    {
      key: "4",
      row: "1 / span 1",
      col: "4 / span 1",
    },
    {
      key: "5",
      row: "2 / span 1",
      col: "4 / span 1",
    },
    {
      key: "6",
      row: "3 / span 1",
      col: "4 / span 1",
    },
    {
      key: "7",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "8",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "9",
      row: "5 / span 1",
      col: "3 / span 1",
    },
    {
      key: "addition",
      row: "5 / span 1",
      col: "2 / span 1",
    },
    {
      key: "subtraction",
      row: "5 / span 1",
      col: "1 / span 1",
    },
    {
      key: "equal",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "plusminus",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "multiplication",
      row: "2 / span 1",
      col: "1 / span 1",
    },
    {
      key: "E",
      row: "2 / span 2",
      col: "2 / span 1",
    },
    {
      key: "C",
      row: "4 / span 1",
      col: "2 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "4 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "4 / span 1",
      col: "3 / span 1",
    },
    {
      key: "4",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "5",
      row: "3 / span 1",
      col: "2 / span 1",
    },
    {
      key: "6",
      row: "3 / span 1",
      col: "3 / span 1",
    },
    {
      key: "7",
      row: "2 / span 1",
      col: "1 / span 1",
    },
    {
      key: "8",
      row: "2 / span 1",
      col: "2 / span 1",
    },
    {
      key: "9",
      row: "2 / span 1",
      col: "3 / span 1",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "subtraction",
      row: "3 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "plusminus",
      row: "1 / span 1",
      col: "2 / span 1",
    },
    {
      key: "multiplication",
      row: "2 / span 1",
      col: "4 / span 1",
    },
    {
      key: "division",
      row: "1 / span 1",
      col: "4 / span 1",
    },
    {
      key: "E",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "C",
      row: "1 / span 1",
      col: "3 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "4 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "4 / span 1",
      col: "3 / span 1",
    },
    {
      key: "4",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "5",
      row: "3 / span 1",
      col: "2 / span 1",
    },
    {
      key: "6",
      row: "3 / span 1",
      col: "3 / span 1",
    },
    {
      key: "7",
      row: "2 / span 1",
      col: "1 / span 1",
    },
    {
      key: "8",
      row: "2 / span 1",
      col: "2 / span 1",
    },
    {
      key: "9",
      row: "2 / span 1",
      col: "3 / span 1",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "subtraction",
      row: "3 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "plusminus",
      row: "1 / span 1",
      col: "2 / span 1",
    },
    {
      key: "multiplication",
      row: "2 / span 1",
      col: "4 / span 1",
    },
    {
      key: "division",
      row: "1 / span 1",
      col: "4 / span 1",
    },
    {
      key: "dot",
      row: "5 / span 1",
      col: "2 / span 1",
    },
    {
      key: "E",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "C",
      row: "1 / span 1",
      col: "3 / span 1",
    },
  ],
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "4 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "4 / span 1",
      col: "3 / span 1",
    },
    {
      key: "4",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "5",
      row: "3 / span 1",
      col: "2 / span 1",
    },
    {
      key: "6",
      row: "3 / span 1",
      col: "3 / span 1",
    },
    {
      key: "7",
      row: "2 / span 1",
      col: "1 / span 1",
    },
    {
      key: "8",
      row: "2 / span 1",
      col: "2 / span 1",
    },
    {
      key: "9",
      row: "2 / span 1",
      col: "3 / span 1",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "subtraction",
      row: "3 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "plusminus",
      row: "1 / span 1",
      col: "2 / span 1",
    },
    {
      key: "multiplication",
      row: "2 / span 1",
      col: "4 / span 1",
    },
    {
      key: "division",
      row: "1 / span 1",
      col: "4 / span 1",
    },
    {
      key: "dot",
      row: "5 / span 1",
      col: "2 / span 1",
    },
    {
      key: "percent",
      row: "1 / span 1",
      col: "3 / span 1",
    },
    {
      key: "E",
      row: "5 / span 1",
      col: "1 / span 1",
    },
    {
      key: "C",
      row: "5 / span 1",
      col: "3 / span 1",
    },
  ],
  [
    {
      key: "0",
      row: "1 / span 5",
      col: "1 / span 4",
    },
  ],
  [
    {
      key: "1",
      row: "4 / span 1",
      col: "1 / span 1",
    },
    {
      key: "2",
      row: "4 / span 1",
      col: "2 / span 1",
    },
    {
      key: "3",
      row: "4 / span 1",
      col: "3 / span 1",
    },
    {
      key: "4",
      row: "3 / span 1",
      col: "1 / span 1",
    },
    {
      key: "5",
      row: "3 / span 1",
      col: "2 / span 1",
    },
    {
      key: "6",
      row: "3 / span 1",
      col: "3 / span 1",
    },
    {
      key: "7",
      row: "2 / span 1",
      col: "1 / span 1",
    },
    {
      key: "8",
      row: "2 / span 1",
      col: "2 / span 1",
    },
    {
      key: "9",
      row: "2 / span 1",
      col: "3 / span 1",
    },
    {
      key: "0",
      row: "5 / span 1",
      col: "1 / span 1",
    },
    {
      key: "addition",
      row: "4 / span 1",
      col: "4 / span 1",
    },
    {
      key: "subtraction",
      row: "3 / span 1",
      col: "4 / span 1",
    },
    {
      key: "equal",
      row: "5 / span 1",
      col: "4 / span 1",
    },
    {
      key: "plusminus",
      row: "1 / span 1",
      col: "2 / span 1",
    },
    {
      key: "multiplication",
      row: "2 / span 1",
      col: "4 / span 1",
    },
    {
      key: "division",
      row: "1 / span 1",
      col: "4 / span 1",
    },
    {
      key: "dot",
      row: "5 / span 1",
      col: "2 / span 1",
    },
    {
      key: "percent",
      row: "1 / span 1",
      col: "3 / span 1",
    },
    {
      key: "E",
      row: "1 / span 1",
      col: "1 / span 1",
    },
    {
      key: "C",
      row: "5 / span 1",
      col: "3 / span 1",
    },
  ],
];

export default Constants;
